<template>
  <Header />
  <div class="tabs customer-filters-container">
    <simplebar>
      <div class="content-sm">
        <ul class="tabs-nav">
          <li>
            <button data-tab="tab-contact" class="btn tab-toggle tab-toggle-tier-1" :class="{ active: filter === 'tier-1' }"
                    @click="filterByTier(1)">
              Tier 1
            </button>
          </li>
          <li>
            <button data-tab="tab-sizing" class="btn tab-toggle tab-toggle-tier-2" :class="{ active: filter === 'tier-2' }"
                    @click="filterByTier(2)">
              Tier 2
            </button>
          </li>
          <li>
            <button data-tab="tab-sizing" class="btn tab-toggle tab-toggle-tier-3" :class="{ active: filter === 'tier-3' }"
                    @click="filterByTier(3)">
              Tier 3
            </button>
          </li>
        </ul>
      </div>
    </simplebar>
    <simplebar>
      <div class="content-sm">
        <ul class="tabs-nav">
          <li v-for="customer_type in types" :key="customer_type.id">
            <button data-tab="tab-contact" class="btn tab-toggle" :class="{ active: type?.toUpperCase() === customer_type.name.toUpperCase() }" v-bind:style="{ 'background-color': customer_type?.type_color?.hex_value || '#FFF' }" @click="filterByType(customer_type)">
              {{ customer_type.name }}
            </button>
          </li>
        </ul>
      </div>
    </simplebar>
    <simplebar v-if="showSubTypes">
      <div class="content-sm">
        <ul class="tabs-nav">
          <li v-for="customer_sub_type in subTypes" :key="customer_sub_type.id">
            <button data-tab="tab-contact" class="btn tab-toggle" :class="{ active: subType?.toUpperCase() === customer_sub_type.name.toUpperCase() }" @click="filterBySubType(customer_sub_type)" v-bind:style="{ 'background-color': customer_sub_type?.sub_type_color?.rgba_value || '#FFF' }">
              {{ customer_sub_type.name }}
            </button>
          </li>
        </ul>
      </div>
    </simplebar>
  </div>
  <SearchProfiles :top="topDistance" @update-profiles="searchForProfiles" />
  <div class="section container" v-bind:class="{ 'section--xlg': showSubTypes, 'section--lg': !showSubTypes}">
    <div class="content">
      <CustomerTable :columns="customerColumns"
                     :rows="customers"
                     :fields="customerFields"
                     :no-data="'No customers found!'"
                     :requestCompleted="requestCustomerCompleted"
                     :sortable="true"
                     :showLastSeeded="true"
                     :displayTypes="true"
                     @update-sort="updateCustomerSort"
                     @row-click="viewCustomerDetails"/>
    </div>
  </div>

</template>

<script>
import simplebar from '../components/simplebar.vue';
import Header from '../components/Header.vue';
import CustomerTable from '../components/CustomerTable.vue';
import SearchProfiles from '../components/SearchProfiles.vue';

export default {
  name: 'Profiles',
  components: { simplebar, Header, CustomerTable, SearchProfiles },
  methods: {
    viewCustomerDetails(customer) {
      this.$router.push(`/customer/${customer.shopify_id}`);
    },
    searchForProfiles(searchTerm) {
      this.customerTableParams.query = searchTerm
      this.setCustomers(this.customerTableParams)
    },
    updateCustomerSort(sortBy, sortDirection){
      this.customerTableParams.sortBy = sortBy
      this.customerTableParams.sortDirection = sortDirection
      this.setCustomers(this.customerTableParams);
    },
    generateQuery(params) {
      var q = `&sort_by=${params.sortBy}&sort_direction=${params.sortDirection}`
      if (params.query) {
        q += `&query=${params.query}`;
      }
      if (params.customer_type) {
        q += `&customer_type=${params.customer_type}`
      }
      if (params.customer_sub_type) {
        q += `&customer_sub_type=${params.customer_sub_type}`
      }
      if (params.filter) {
        q += `&filter=${params.filter}&filter_value=${params.filter_value}`
      }
      return q;
    },
    setCustomers(params) {
      let q = this.generateQuery(params)
      this.axios.get('/v1/customers.json?no_pagination=true' + q)
        .then(response => {
          if (typeof response.data.records !== 'undefined') {
            this.customers = response.data.records;
            this.full_customers_list = response.data.records;
            this.requestCustomerCompleted = true;
          }
        })
        .catch((error) => {
          console.log(error)
        });
    },
    filterByTier(tier) {
      if (this.customerTableParams.filter_value === tier) {
        this.customerTableParams.filter = null
        this.customerTableParams.filter_value = null
        this.filter = null
      } else {
        this.customerTableParams.filter = 'tier'
        this.customerTableParams.filter_value = tier
        this.filter = `tier-${tier}`
      }
      this.setCustomers(this.customerTableParams);
    },
    filterByType(type) {
      if (this.type === type.name) {
        this.type = null
        this.subTypes = []
        this.showSubTypes = false
        this.topDistance = 230
        this.customerTableParams.customer_type = null
        this.customerTableParams.customer_sub_type = null
      } else {
        this.type = type.name
        this.subTypes = type.sub_types
        this.customerTableParams.customer_type = type.id
        this.customerTableParams.customer_sub_type = null
        if(type.sub_types.length > 0) {
          this.showSubTypes = true
          this.topDistance = 315
        } else {
          this.showSubTypes = false
          this.topDistance = 230
          this.subType = null
        }
      }
      this.setCustomers(this.customerTableParams);
    },
    filterBySubType(subType) {
      if (this.subType === subType.name) {
        this.subType = null
        this.customerTableParams.customer_sub_type = null
      } else {
        this.subType = subType.name
        this.customerTableParams.customer_sub_type = subType.id
      }

      this.setCustomers(this.customerTableParams);
    },
    setCustomersFilter() {
      this.filter = `customers`
      this.customerTableParams.filter = 'customers'
      this.setCustomers(this.customerTableParams);
    },
    scrollHandler(top) {
      setTimeout(() => {
        window.scrollTo({
          top: top,
        });
      }, 100);
    },
  },
  data() {
    return {
      filter: '',
      type: '',
      subType: '',
      subTypes: [],
      types: [],
      showSubTypes: false,
      customers: [],
      topDistance: 230,
      customerColumns: [{ name: 'last_seeded', label: 'Last seeded date', classNames: 'col__last-seeded' }],
      customerFields: [
        {
          name: 'last_seeded', format: (data) => {
            return data.last_seeded ? this.helpers.formatDateShort(data.last_seeded) : '-'
          },
          classNames: () => { return 'col__last-seeded-date'; }
        },
      ],
      requestCustomerCompleted: false,
      full_customers_list: this.customers,
      customerTableParams: {
        sortBy: 'full_name',
        sortDirection: 'asc',
        filter: null,
        filter_value: null,
        customer_type: null,
        customer_sub_type: null,
      },
    }
  },
  watch: {
    customerTableParams: {
      handler(newVal) {
        sessionStorage.setItem('customerTableParams', JSON.stringify(newVal));
      },
      deep: true,
    }
  },
  mounted() {
    let params = JSON.parse(sessionStorage.getItem('customerTableParams')) || this.customerTableParams;
    this.customerTableParams = params;
    this.filter = `${params.filter}-${params.filter_value}`;
    this.customer_sub_type = params.customer_sub_type;
    document.body.classList.remove('menu-open');
    this.setCustomers(params);
    this.axios.get('/v1/types.json')
      .then(response => {
        window.dispatchEvent(new CustomEvent('profiles-scroll-ready', {
          detail: {
            page: window.scrollY
          }
        }))
        this.types = response.data.records;
        let type = this.types.find(type => type.id === params.customer_type);
        if (type) {
          this.filterByType(type);
          if (type.sub_types.length > 0) {
            let subType = type.sub_types.find(subtype => subtype.id === params.customer_sub_type);
            if (subType) {
              this.filterBySubType(subType);
            }
          }
        }
      })
      .catch((error) => {
        console.log(error)
      });

    window.addEventListener('profiles-scroll', (event) => {
      if (event?.detail) {
        this.scrollHandler(event.detail.position.top)
      }
    })
  },
  beforeUnmount() {
    window.removeEventListener('profiles-scroll', this.scrollHandler);
  }
}
</script>
<style scoped>
  .section--lg {
    padding-top: 310px;
  }

  .section--xlg {
    padding-top: 380px;
  }
  .customer-filters-container {
    position: fixed;
    top: 61px;
    width: 100%;
    background-color: white;
    z-index: 1;
  }

  .content-sm {
    display: flex;
    justify-content: center;
  }

  .tab-toggle {
    color: black;
  }

  .tab-toggle-tier-1 {
    background-color: #A5C3D0;
  }

  .tab-toggle-tier-2 {
    background-color: #F4C474;
  }

  .tab-toggle-tier-3 {
    background-color: #DF9B85;
  }

  .tab-toggle-customers {
    background-color: #F7F7F7;
  }

  @media screen and (max-width: 992px) {
  .content-sm {
    justify-content: flex-start;
    overflow: scroll
  }
}
</style>
